import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Titre from '../../Titre';
import SousTitre from '../../SousTitre';
import LogoElect from "../../img/Elect.png";
import CarreLogoInput2Bis from '../../CarreLogo/CarreLogoInput2-bis';
import CarreLogoInput2 from '../../CarreLogo/CarreLogoInput2';
import LogoChauf from "../../img/ChauffageUrbain.png";
import Logogpl from "../../img/GPL.png";
import Logogaz from "../../img/gaz.png";
import LogoBoi from "../../img/bois.png";
import LogoFioul from "../../img/fioule.png";
import LogoPanneauSol from "../../img/panneauSol.png";
import LogoPaneauVolt from "../../img/panneauPhoto.png";
import LogoEolienne from "../../img/eolienne.png";
import "./form.css";

const ConsomationAnnuelCollectif = ({ setDomicileData, domicileData, setDisplayBilan }) => {

  const handleConsommation = (data) => {
    const [index, value, column] = data;

    const mapping = {
      0: ['ElectriciqueUnit', 'BoisUnit'],
      1: ['ElectriciqueEuro', 'BoisEuro'],
    };

    setDomicileData((prevDomicile) => {
      setDisplayBilan(false);
      const updatedDomicile = { ...prevDomicile };

      if (mapping[index] && mapping[index][column]) {
        const key = mapping[index][column];
        updatedDomicile[key] = value === "" ? null : value;
      }

      return updatedDomicile;
    });
  };

  const handleLigne2 = (data) => {
    const [index, value, column] = data;

    setDomicileData((prevDomicile) => {
      setDisplayBilan(false);
      const updatedDomicile = { ...prevDomicile };

      switch (column) {
        case 0:
          updatedDomicile.PanneauSol = value === "" ? null : value;
          break;

        case 1:
          updatedDomicile.PanneauPhoto = value === "" ? null : value;
          break;

        case 2:
          updatedDomicile.Eolienne = value === "" ? null : value;
          break;
        default:
          break;
      }
      return updatedDomicile;
    });
  };

  return (
    <div className="conso">
      <Titre Titre="Consommation annuelle individuelle supplémentaire" />
      <div className="h61">
        Indiquez votre consommation annuelle individuelle en euro ou unité d’achat pour votre logement.
      </div>
      <div className="row col-12">
        <div className="col-md-6 col-lg-3 col-12">
          <CarreLogoInput2Bis
            logo={LogoElect}
            titregras="Electricité"
            titre="Contrat électricité"
            onChange={(data) => handleConsommation([...data, 0])}
            currentValeur={domicileData.ElectriciqueUnit}
            currentValeur2={domicileData.ElectriciqueEuro}
          />
        </div>
        <div className="col-md-6 col-lg-3 col-12">
          <CarreLogoInput2Bis
            logo={LogoBoi}
            titregras="Bois Plaquettes forestières"
            titre="Chauffage au poele ou avec une cheminée"
            unit='steres'
            onChange={(data) => handleConsommation([...data, 1])}
            currentValeur={domicileData.BoisUnit}
            currentValeur2={domicileData.BoisEuro}
          />
        </div>
      </div>
      <div className="h61">
        Je produis et consomme une partie de mon énergie (l’énergie produite pour la revente n’est pas prise en compte):
      </div>
      <div className="row col-12">
        <div className="col-md-6 col-lg-3 col-12">
          <CarreLogoInput2
            logo={LogoPanneauSol}
            titregras="Panneau solaire"
            titre="Production de chaleur grâce au Soleil"
            nombre={1}
            unit1='kWh'
            onChange={(data) => handleLigne2([...data, 0])}
            currentValeur={domicileData.PanneauSol}
          />
        </div>
        <div className="col-md-6 col-lg-3 col-12">
          <CarreLogoInput2
            logo={LogoPaneauVolt}
            titregras="Panneau photovoltaïque"
            titre="Production d’énergie grâce au Soleil"
            nombre={1}
            unit1='kWh'
            onChange={(data) => handleLigne2([...data, 1])}
            currentValeur={domicileData.PanneauPhoto}
          />
        </div>
        <div className="col-md-6 col-lg-3 col-12">
          <CarreLogoInput2
            logo={LogoEolienne}
            titregras="Eolienne"
            titre="Production d’électricité grâce au vent"
            nombre={1}
            unit1='kWh'
            onChange={(data) => handleLigne2([...data, 2])}
            currentValeur={domicileData.Eolienne}
          />
        </div>
      </div>
    </div>
  );
};


export default ConsomationAnnuelCollectif;
